<div [ngClass]="appShellClass">
    <main [ngClass]="mainClass">
        <router-outlet></router-outlet>
    </main>
</div>
